import { Typography } from 'antd'
import {
    AZURE_RADIANCE_COLOR,
    BRAND_BLUE,
    CHARCOAL_BLUE_COLOR,
    CHARCOAL_NAVY_COLOR,
    COMET_COLOR,
    DARK_MODE,
    GUNMETAL_COLOR,
    LIGHT_GRAY_COLOR,
    TRANSPARENT,
    WHITE_COLOR,
} from './constants'
import {
    BLACK_COLOR,
    BLACK_COLOR_2_OPACITY,
    BLACK_COLOR_88_OPACITY,
    BRIGHT_LIGHT_BLUE_COLOR,
    BRIGHT_WARNING_COLOR,
    COLOR_SELECT_OPEN_LIGHT,
    DARK_WARNING_COLOR,
    DUST_RED_COLOR,
    ERROR_COLOR,
    GREEN_SUCCESS_COLOR,
    ICE_BLUE_COLOR,
    LIGHT_BLUE,
    LIGHTER_GRAY_COLOR,
    LIGHTEST_GRAY_COLOR,
    OFF_GREY_COLOR,
    RUST_BLUE_COLOR,
    VIVID_GREEN_COLOR,
    WHITE_COLOR_88_OPACITY,
} from './constants/colors'

export const themeComponentCreator = (theme) => {
  if (theme == DARK_MODE) {
    return {
      Card: {
        colorBgContainer: CHARCOAL_BLUE_COLOR,
        colorBorderSecondary: COMET_COLOR,
        headerPadding: 16,
      },
      Popover: {
        zIndexPopup: 1000,
        colorBgElevated: CHARCOAL_NAVY_COLOR,
        colorBorder: COMET_COLOR,
      },
      Pagination: {
        itemActiveBg: WHITE_COLOR,
        colorBgContainer: '',
      },
      Layout: {
        headerBg: CHARCOAL_NAVY_COLOR,
        bodyBg: RUST_BLUE_COLOR,
        siderBg: CHARCOAL_NAVY_COLOR,
      },
      Button: {
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        defaultHoverBg: CHARCOAL_NAVY_COLOR,
        colorPrimary: WHITE_COLOR,
        primaryColor: CHARCOAL_NAVY_COLOR,
        colorPrimaryHover: LIGHT_GRAY_COLOR,
        colorBorder: COMET_COLOR,
      },
      /* Radio: {
        buttonBg: CHARCOAL_NAVY_COLOR,
        buttonSolidCheckedBg: WHITE_COLOR,
        buttonSolidCheckedColor: COMET_COLOR,
        colorPrimaryHover: LIGHT_GRAY_COLOR,
      }, */
      Table: {
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        colorBorderSecondary: COMET_COLOR,
        headerBg: CHARCOAL_NAVY_COLOR,
        headerColor: WHITE_COLOR,
        headerSplitColor: TRANSPARENT,
        borderColor: COMET_COLOR,
        cellPaddingBlock: 4,
        cellPaddingInline: 8,
      },
      Spin: {
        colorPrimary: 'rgba(255, 255, 255, 0.45)',
      },
      Modal: {
        fontWeightStrong: 600,
        contentBg: GUNMETAL_COLOR,
        headerBg: GUNMETAL_COLOR,
      },
      /* Tabs: {
        itemColor: LIGHT_GRAY_COLOR,
        itemSelectedColor: WHITE_COLOR,
        boxShadowSecondary: 'none',
      },
      Carousel: {
        colorBgContainer: WHITE_COLOR,
      },
      Drawer: {
        colorBgElevated: CHARCOAL_NAVY_COLOR,
      }, */
      Tooltip: {
        colorBgSpotlight: BLACK_COLOR_88_OPACITY,
        colorTextLightSolid: WHITE_COLOR,
      },
      /* Badge: {
        colorTextLightSolid: BLACK_COLOR,
      }, */
      Menu: {
        itemBg: CHARCOAL_NAVY_COLOR,
        itemSelectedBg: LIGHT_BLUE,
        itemSelectedColor: WHITE_COLOR_88_OPACITY,

        itemHoverBg: 'transparent',

        subMenuItemBg: CHARCOAL_NAVY_COLOR,
        subMenuItemSelectedColor: WHITE_COLOR_88_OPACITY,
      },
      Input: {
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        colorBorder: COMET_COLOR,
        hoverBorderColor: LIGHT_GRAY_COLOR,
      },
      Select: {
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        colorBgElevated: CHARCOAL_NAVY_COLOR,
        colorBorder: COMET_COLOR,
        hoverBorderColor: LIGHT_GRAY_COLOR,
      },
      Message: {
        contentBg: CHARCOAL_NAVY_COLOR,
        colorInfo: WHITE_COLOR,
        colorSuccess: VIVID_GREEN_COLOR,
        colorWarning: DARK_WARNING_COLOR,
        colorError: DUST_RED_COLOR,
      },
      Segmented: {
        trackBg: CHARCOAL_NAVY_COLOR,
        itemColor: WHITE_COLOR,
        itemSelectedBg: WHITE_COLOR,
        itemSelectedColor: BLACK_COLOR,
      },
      List: {
        colorBorder: COMET_COLOR,
        colorSplit: COMET_COLOR,
        headerBg: CHARCOAL_NAVY_COLOR,
        borderRadiusLG: 6,
        itemPadding: '7px 0',
        paddingLG: 16
      },
      Collapse: {
        headerBg: CHARCOAL_NAVY_COLOR,
        contentBg: GUNMETAL_COLOR,
        colorBorder: COMET_COLOR,
      },
      Tag: {
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        colorBorder: COMET_COLOR,
      },
      Divider: {
        colorSplit: COMET_COLOR,
      },
      DatePicker: {
        colorSplit: COMET_COLOR,
        colorBorder: COMET_COLOR,
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        hoverBorderColor: LIGHT_GRAY_COLOR,

        colorBgElevated: CHARCOAL_NAVY_COLOR,
      },
      Typography: {
        colorSuccess: GREEN_SUCCESS_COLOR,
      }
    }
  } else {
    return {
      Popover: {
        zIndexPopup: 1000,
        colorBgElevated: WHITE_COLOR,
        colorBorder: OFF_GREY_COLOR,
      },
      Card: {
        colorBgContainer: WHITE_COLOR,
        colorBorderSecondary: LIGHT_GRAY_COLOR,
        headerPadding: 16,
      },
      Layout: {
        headerBg: WHITE_COLOR,
        bodyBg: LIGHTEST_GRAY_COLOR,
        siderBg: WHITE_COLOR,
      },
      Table: {
        headerBg: LIGHTER_GRAY_COLOR,
        headerColor: CHARCOAL_NAVY_COLOR,
        headerSplitColor: TRANSPARENT,
        borderColor: OFF_GREY_COLOR,
        cellPaddingBlock: 4,
        cellPaddingInline: 8,
      },
      Modal: {
        fontWeightStrong: 600,
        contentBg: WHITE_COLOR,
        headerBg: WHITE_COLOR,
      },
      Spin: {
        colorPrimary: 'rgba(0, 0, 0, 0.88)',
      },
      Tabs: {
        itemColor: LIGHT_GRAY_COLOR,
        itemSelectedColor: BLACK_COLOR,
      },
      Button: {
        colorPrimary: BRAND_BLUE,
        colorBorder: OFF_GREY_COLOR,
      },
      /* Radio: {
        colorPrimary: BRAND_BLUE,
      },
      Carousel: {
        colorBgContainer: BLACK_COLOR,
      }, */
      Tooltip: {
        colorBgSpotlight: BLACK_COLOR_88_OPACITY,
        colorTextLightSolid: WHITE_COLOR,
      },
      Menu: {
        itemBg: WHITE_COLOR,
        itemColor: BLACK_COLOR_88_OPACITY,

        itemHoverBg: 'transparent',

        itemSelectedBg: ICE_BLUE_COLOR,
        itemSelectedColor: BRIGHT_LIGHT_BLUE_COLOR,

        subMenuItemBg: BLACK_COLOR_2_OPACITY,
        subMenuItemSelectedColor: BLACK_COLOR_88_OPACITY,
      },
      Input: {
        colorBorder: OFF_GREY_COLOR,
        hoverBorderColor: COLOR_SELECT_OPEN_LIGHT,
      },
      Select: {
        colorBorder: OFF_GREY_COLOR,
        hoverBorderColor: COLOR_SELECT_OPEN_LIGHT,
      },
      Message: {
        contentBg: WHITE_COLOR,
        colorInfo: AZURE_RADIANCE_COLOR,
        colorSuccess: VIVID_GREEN_COLOR,
        colorWarning: BRIGHT_WARNING_COLOR,
        colorError: ERROR_COLOR,
      },
      List: {
        colorBorder: OFF_GREY_COLOR,
        colorSplit: OFF_GREY_COLOR,
        headerBg: LIGHTER_GRAY_COLOR,
        borderRadiusLG: 6,
        itemPadding: '7px 0',
        paddingLG: 16
      },
      Segmented: {
        trackBg: WHITE_COLOR,
        itemSelectedBg: AZURE_RADIANCE_COLOR,
        itemSelectedColor: WHITE_COLOR,
      },
      Collapse: {
        headerBg: LIGHTER_GRAY_COLOR,
        contentBg: WHITE_COLOR,
        colorBorder: OFF_GREY_COLOR,
      },
      Tag: {
        // colorBgContainer: LIGHTEST_GRAY_COLOR,
        colorBorder: OFF_GREY_COLOR,
      },
      Divider: {
        colorSplit: OFF_GREY_COLOR,
      },
      DatePicker: {
        colorSplit: OFF_GREY_COLOR,
        colorBorder: OFF_GREY_COLOR,
        colorBgContainer: WHITE_COLOR,
        hoverBorderColor: COLOR_SELECT_OPEN_LIGHT,

        colorBgElevated: WHITE_COLOR,
      },
      Typography: {
        colorSuccess: GREEN_SUCCESS_COLOR,
      },
    }
  }
}
